import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { BulkPurchaseData } from '../interfaces/BulkPurchase.model';

export const selectBulkPurchase = (
  state: SpartacuxProductDiscoveryDomainState,
): BulkPurchaseData[] => state.productDiscovery?.bulkPurchase?.data || [];

export const selectBulkOfProduct = (
  state: SpartacuxProductDiscoveryDomainState,
  productId: number,
): BulkPurchaseData | null =>
  selectBulkPurchase(state)?.find((data) => data.productId === productId) ||
  null;
